export default {
    bindings: {
        getSuggestions: '&',
        events: '<',
        event: '<',
        upgrade: '<',
        parent: '<',
        type: '@',
        guest: '<'
    },
    controller: 'upgradeEventController',
    template: require('../views/upgrade.event.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/checkout/components/upgrade.event.component.js